module.exports = __webpack_public_path__ + "static/5_section-img-3f57ffcbabba870da5b6a6163d143714.png";